import React, { useEffect, useState } from 'react'
import { Button, Empty, Row } from 'antd'
import { Plus } from '@phosphor-icons/react'
import { leagueEventStore } from 'state/league/leagueEvent'
import AddDevision from './Modals/AddDevision'
import {
  useDeleteDivision,
  useGetLeagueDivisions,
} from 'api/league/LeagueCreation/leagueDivision'
import { DivisonListingResp } from 'types/league/division'
import Spinner from 'components/Spinner'
import AlertModal from 'helper/AlertModal'
import { infoMessage } from 'api/global'
import Division from './Division'
import EmptyState from 'assets/Images/empty_state.svg'
import ManageDivision from './Modals/ManageDivision'
interface LeagueStep3Props {
  handleNext: () => void
  handleBack: () => void
}

const Step3: React.FC<LeagueStep3Props> = ({ handleNext, handleBack }) => {
  const {
    addDevisionModal,
    setAddDevisonModal,
    divisionData,
    setDivisionData,
    leagueData,
    setLeagueData,
    manageDivisionModal,
    setManageDivisionModal,
  } = leagueEventStore(store => ({
    addDevisionModal: store.addDevisionModal,
    setAddDevisonModal: store.setAddDevisonModal,
    divisionData: store.divisionData,
    setDivisionData: store.setDivisionData,
    leagueData: store.leagueData,
    setLeagueData: store.setLeagueData,
    manageDivisionModal: store.manageDivisionModal,
    setManageDivisionModal: store.setManageDivisionModal,
  }))
  const [alertModal, setAlertModal] = useState<boolean>(false)
  const {
    data: devisionsListData,
    isLoading: devisionsListLoading,
    isFetching: devisionsListFetching,
    refetch: refetchDevisionsList,
  } = useGetLeagueDivisions(leagueData?._id)
  const { mutate: deleteDivisionMutation, isLoading: deleteDivisionLoading } =
    useDeleteDivision()

  const handleYesDelete = () => {
    if (!divisionData?._id) return
    deleteDivisionMutation(divisionData._id, {
      onSuccess: () => {
        devisionsListData?.length === 1 &&
          setLeagueData({
            ...leagueData,
            statuses: { ...leagueData.statuses, divisions: false },
          })
        setAlertModal(false)
        setDivisionData(null)
      },
      onError: () => {
        setAlertModal(false)
        setDivisionData(null)
      },
    })
  }
  const alertModalData = {
    name: 'Delete',
    heading: 'Delete division',
    message1: 'Are you sure you want to delete this division?',
  }

  const handleDeleteDivsion = (division: DivisonListingResp) => {
    setDivisionData(division)
    setAlertModal(true)
  }

  const handleNextClick = () => {
    if (!devisionsListData?.length) return infoMessage('Please add divisions')
    handleNext()
  }
  const handleManageDivision = (division: DivisonListingResp) => {
    setDivisionData(division)
    setManageDivisionModal(true)
  }

  useEffect(() => {
    refetchDevisionsList()
  }, [])

  return (
    <div className="mt-15px">
      <h2 className="text-24 w-600">Add divisions</h2>
      {devisionsListLoading || devisionsListFetching ? (
        <div className="py-20px flex align-center justify-center">
          <Spinner />
        </div>
      ) : (
        <div
          className="overflow-auto-y scroller scroller-lg"
          style={{ height: `calc(100vh - 400px)` }}
        >
          {!devisionsListData?.length ? (
            <div className="flex flex-col align-center justify-center h-20">
              <div>
                <img src={EmptyState} alt="empty-state" />
                <h4 className="text-16 w-600 mt-20px">No division added</h4>
              </div>
            </div>
          ) : (
            <>
              {devisionsListData.map(
                (item: DivisonListingResp, index: number) => {
                  return (
                    <Division
                      key={index}
                      item={item}
                      handleDeleteDivsion={handleDeleteDivsion}
                      handleManageDivision={handleManageDivision}
                    />
                  )
                },
              )}
            </>
          )}
        </div>
      )}

      <div className="btn-container">
        <Row justify="space-between" className="mb-26 mt-40px">
          <Button
            className="cancel-button flex align-center justify-center gap-10px"
            onClick={() => {
              setDivisionData(null)
              setAddDevisonModal(true)
            }}
          >
            <Plus size={20} color="#000" />
            <span>Add division</span>
          </Button>
          <Button className="stepper-button" onClick={handleNextClick}>
            Next
          </Button>
        </Row>
      </div>

      {addDevisionModal && <AddDevision />}
      {manageDivisionModal && <ManageDivision />}

      {alertModal && (
        <AlertModal
          isModalVisible={alertModal}
          setIsModalVisible={setAlertModal}
          data={alertModalData}
          onYesClick={handleYesDelete}
          loading={deleteDivisionLoading}
        />
      )}
    </div>
  )
}

export default Step3
